(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-lob-kritik"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var root = document.querySelector('[data-ml-lob-kritik]');
    if (!root || root.dataset.mlLkInit) return;
    root.dataset.mlLkInit = '1';

    var form = document.getElementById('lk-form');
    if (!form) return;

    /* ── Vorbelegung aus den Klaviyo-Parametern (?stars/order/email/name) ── */
    var p = new URLSearchParams(window.location.search);
    function setz(id, wert) {
      var el = document.getElementById(id);
      if (el && wert) el.value = wert;
    }
    setz('lk-name', p.get('name'));
    setz('lk-email', p.get('email'));
    setz('lk-order', p.get('order'));

    var sterne = p.get('stars');
    if (sterne) {
      var s = document.getElementById('lk-sterne');
      if (s) s.value = sterne + ' von 5';
    }

    /* ── TP-Marker: Besucher kam über die Bewertungsmail ────────────────
       Herkunft = URL trägt die Klaviyo-Params (?stars und/oder ?order).
       Dann bekommt contact[Quelle] den Zusatz " (TP)" für die
       Gorgias-Zuordnung. Ohne JS bleibt die Quelle ohne Marker. */
    var quelle = document.getElementById('lk-quelle');
    if (quelle) {
      var ausMail = !!(sterne || (p.get('order') || '').trim());
      if (ausMail && quelle.value.indexOf(' (TP)') === -1) {
        quelle.value += ' (TP)';
      }
    }

    /* ── Absende-Checks (Komfort; ohne JS greift das native required) ──── */
    var text = document.getElementById('lk-text');

    form.addEventListener('submit', function (e) {
      /* Honeypot: wurde das unsichtbare Fax-Feld befüllt, war es ein Bot ->
         Versand still blocken. Bots OHNE JavaScript werden hier NICHT
         gefangen (Shopify wertet das Feld serverseitig nicht aus) —
         Backstop ist eine Gorgias-Regel auf die "Fax:"-Zeile in der Mail. */
      var hp = document.getElementById('lk-hp');
      if (hp && hp.value) {
        e.preventDefault();
        return;
      }

      if (text) {
        var inhalt = (text.value || '').trim();
        var fehler = document.getElementById('lk-text-fehler');

        if (inhalt.length < 5) {
          e.preventDefault();
          text.classList.add('lk--invalid');
          if (fehler) fehler.classList.add('is-on');
          text.focus();
        }
      }
    });

    if (text) {
      text.addEventListener('input', function () {
        text.classList.remove('lk--invalid');
        var fehler = document.getElementById('lk-text-fehler');
        if (fehler) fehler.classList.remove('is-on');
      });
    }

    /* ── Nach erfolgreichem Versand zum Danke-Block scrollen ───────────── */
    if (window.location.hash === '#contact_form' || root.querySelector('.lk__danke')) {
      var danke = root.querySelector('.lk__danke');
      if (danke) danke.scrollIntoView({ block: 'center' });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
